import { render, staticRenderFns } from "./V2CartsTotal.vue?vue&type=template&id=b4d553be&scoped=true&"
import script from "./V2CartsTotal.vue?vue&type=script&lang=js&"
export * from "./V2CartsTotal.vue?vue&type=script&lang=js&"
import style0 from "./V2CartsTotal.vue?vue&type=style&index=0&id=b4d553be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d553be",
  null
  
)

export default component.exports